// Centralised site config. Replace WHATSAPP_NUMBER once the client provides theirs.
// Format must be international without leading "+" and no spaces (E.164 minus the +).
export const WHATSAPP_NUMBER = "212600000000";
export const WHATSAPP_DISPLAY = "+212 600 000 000";
export const BRAND = {
    name: "Dentiprime",
    tagline: "L'équipement dentaire conçu pour l'excellence.",
    email: "contact@dentiprime.com",
};

export const buildWhatsappUrl = (text, number = WHATSAPP_NUMBER) => {
    const encoded = encodeURIComponent(text);
    return `https://wa.me/${number}?text=${encoded}`;
};
